import { render, staticRenderFns } from "./kjProduct.vue?vue&type=template&id=50d52db0&scoped=true&"
import script from "./kjProduct.vue?vue&type=script&lang=js&"
export * from "./kjProduct.vue?vue&type=script&lang=js&"
import style0 from "./kjProduct.vue?vue&type=style&index=0&id=50d52db0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d52db0",
  null
  
)

export default component.exports